import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { useAuth } from '../../AuthContext';
import { useAccount, useConnect, useDisconnect } from 'wagmi'

import { bindAddress, followOnTwitter, tweetOnTwitter, joinDiscord, joinTelegram, shearWithfriends, followOnInsta, followOnYoutube, retweet } from '../../function';

export default function Package() {
  const auth = useAuth();
  const { address, isConnected } = useAccount()
  const [user, setUser] = useState()

  useEffect(() => {
    setUser(auth.user)
  })

  useEffect(() => {

  }, [user])

  function copyToClipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      console.log('Text copied to clipboard');
      Swal.fire(
        'Code Copied to Clipboard',
        // 'success'
      )
    } catch (err) {
      console.error('Unable to copy:', err);
    } finally {
      document.body.removeChild(textarea);
    }
  }
  const referral = () => {
    Swal.fire({
      title: 'Your Referral is',
      text: `https://globuschain.com/?referral=${address.substring(0, 6)}`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Copy Referral'
    }).then((result) => {
      if (result.isConfirmed) {
        copyToClipboard(`https://globuschain.com/?referral=${address}`)
      }
    })
  }



  return (
    <section id='tasks' className="pt-120 pb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center">
            <div className="section-header">
              <h2 className="section-title">
                <span className="font-weight-normal">Task</span>{" "}
                <b className="base--color">Plans</b>
              </h2>
              {isConnected ?
                <h3>
                  What’s more, if you do every one of them they will total up to 17 entries into the competition!
                </h3>
                :
                <p>
                  Please Connect You Wallet
                </p>}
            </div>
          </div>
        </div>
        {isConnected && (
          <>
            {user?.bindedAddress.length <= 0 && (
              <div
                style={{ border: '3px solid #cca354' }}
                className="subscribe-wrapper bg_img mb-5">
                <div style={{ position: 'relative' }} className="align-items-center">
                  <div style={{ textAlign: 'center' }}>
                    <h2 className="title">Enter your crypto wallet address <div className="package-card__range base--color">
                      {/* 1 Entry */}
                    </div></h2>
                  </div>
                  <div className="">
                    <form className="subscribe-form">
                      <input
                        id='bind'
                        type="text"
                        className="form-control"
                        // value={user?.walletAddress}
                        placeholder={user?.walletAddress}
                      />
                      <button type='button' onClick={() => { bindAddress(address) }} className="subscribe-btn">
                        💳
                      </button>
                    </form>

                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {isConnected && (

          <>


            <div className='row justify-content-center mb-none-30 p-20'>
              <div className="col-xl-6 col-lg-6 col-md-6 mb-30">
              <div style={{padding:'30px' , justifyContent:'space-around'}} className='mt-30'>
              <h3>Worth of Globus Smart Coins (GLSC)!</h3>
                <p>
                  That’s right, we’re giving 5 lucky person the chance to win $100k worth of GLSC. To enter, simply follow the steps in the competition box, or follow the steps below.
                </p>
              
                <p className="mt-4">
                We want to give our community the best possible chance to win this prize, that’s why we’ve given you not one, not two, but nine ways to enter our competition.
                </p>
              </div>
              </div>
              <div className="col-xl-5 col-lg-4 col-md-6 mb-30">

                <div
                  className="package-card text-right bg_img"
                  data-background="assets/images/bg/bg-4.png"
                >
                  <h4 className="package-card__title base--color mb-2">Task 1</h4>
                  <div >
                    <h2>Simple referral programme</h2>
                    <ul className="package-card__features mt-4">
                      <li>
                        Login using your wallet address and create your affiliate link . Each referral who buys our tokens you get 5% of the total tokens bought by your referrals at the time we start the claiming process of the tokenz.
                      </li>


                    </ul>
                  </div>
                  <a onClick={referral} className="cmn-btn btn-md mt-4">
                    Your Referral Code
                  </a>
                </div>

              </div>

            </div>


            <div style={{marginTop:'10px'}} className='row justify-content-center mb-none-30 p-20'>
              <div className="col-xl-5 col-lg-4 col-md-6 mb-30">
                <div
                  className="package-card text-left bg_img"
                  data-background="assets/images/bg/bg-4.png"
                >
                  <h4 className="package-card__title base--color mb-2">Task 2</h4>
                  <h2>Win $100K Worth of Globus Smart Coins (GLSC)!</h2>
                  <ul className="package-card__features mt-4">
                    <li>
                      1. Enter your crypto wallet address = 1 entry
                    </li>
                    <li>
                      2. Follow GlobusChain on Twitter = 1 entry
                      {/* <svg style={{marginLeft:'auto'}} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 48 48">
                      <path fill="#B59410" fill-rule="evenodd" d="M38,42H10c-2.209,0-4-1.791-4-4V10c0-2.209,1.791-4,4-4h28	c2.209,0,4,1.791,4,4v28C42,40.209,40.209,42,38,42z" clip-rule="evenodd"></path><path fill="#fff" d="M34.257,34h-6.437L13.829,14h6.437L34.257,34z M28.587,32.304h2.563L19.499,15.696h-2.563 L28.587,32.304z"></path><polygon fill="#fff" points="15.866,34 23.069,25.656 22.127,24.407 13.823,34"></polygon><polygon fill="#fff" points="24.45,21.721 25.355,23.01 33.136,14 31.136,14"></polygon>
                      </svg> */}
                    </li>
                    <li>
                      3. Tweet about GlobusCain and tag Elon Musk = 5 entries
                    </li>
                    <li>
                      4. Join the GlobusChain discord = 1 entry
                    </li>
                    <li>
                      5. Join the GlobusChain on telegram = 1 entry
                    </li>
                    <li>
                      6. Share with your friends = 5 entries
                    </li>
                    <li>
                      7. Follow and like GlobusChain on instagram = 1 entry
                    </li>
                    <li>
                      8. Follow and like GlobusChain on YouTube = 1 entry
                    </li>
                    <li>
                      9. Retweet GlobusChain pinned message on Twitter = 1 entry
                    </li>
                  </ul>
                  <a className="cmn-btn btn-md mt-4">
                    Attempt Task
                  </a>

                </div>

              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 mb-30">
            <img style={{marginTop:'50%', borderRadius:'6px'}} src='https://images.squarespace-cdn.com/content/v1/5de54d7724b1dd71d89bb6df/b7a779fb-b806-416c-9e79-fef7bbdf9cb2/background2.gif' alt='...' />
              </div>

            </div>




            <div style={{marginTop:'20px'}} className="row justify-content-center">


              <div className="col-xl-6 col-lg-4 col-md-6 mb-30">
                <div
                  className="package-card text-center bg_img"
                  data-background="assets/images/bg/bg-4.png"
                >
                  <h4 className="package-card__title base--color mb-2">Task 3</h4>
                  <div style={{margin:'20px'}} >
                    <h2>Referral programme for influencers</h2>
                    <ul className="package-card__features mt-4">
                      <li>
                        minimum followers should be 5k +
                      </li>
                      <li>
                        25 usd worth of glsc for every share on Twitter , Facebook, Instagram, telegram and discord
                      </li>
                      <li>
                        Also chance to earn normal referral programme by getting link
                      </li>

                    </ul>
                  </div>
                  <a className="cmn-btn btn-md mt-4">
                    Buy
                  </a>
                </div>

              </div>
              <div className="col-xl-5 col-lg-4 col-md-6 mb-30">
                <div
                  className="package-card text-center bg_img"
                  data-background="assets/images/bg/bg-4.png"
                >
                  <h4 className="package-card__title base--color mb-2">Task 4</h4>
                  <div style={{margin:'58px'}}  >
                    <h2>NFT Airdrops</h2>
                    <ul className="package-card__features mt-4">
                      <li>
                        Any one who buys usd 250 worth of tokens will get a airdrop of one unique EGOE NFT check life2.io worth 100 usd as airdrop
                      </li>
                    </ul>
                  </div>
                  <a  className="cmn-btn btn-md mt-4">
                    Buy
                  </a>
                </div>

              </div>

              {/* {!user?.fTwitter && (
          <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
            <div
              className="package-card text-center bg_img"
              data-background="assets/images/bg/bg-4.png"
            >
              <h4 className="package-card__title base--color mb-2">Twitter</h4>
              <ul className="package-card__features mt-4">
                <li>Follow GlobusChain on Twitter </li>
              </ul>
              <div className="package-card__range mt-5 base--color">
                1 Entry
              </div>
              <a onClick={()=>{followOnTwitter(address)}} href=" https://twitter.com/globuschain" target='_blank' className="cmn-btn btn-md mt-4">
                Attempt Task
              </a>
            </div>

          </div>
          )}
          {!user?.tTwitter && (
          <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
            <div
              className="package-card text-center bg_img"
              data-background="assets/images/bg/bg-4.png"
            >
              <h4 className="package-card__title base--color mb-2">Twitter </h4>
              <ul className="package-card__features mt-4">
                <li>Tweet about GlobusCain and tag Elon Musk </li>

              </ul>
              <div className="package-card__range mt-5 base--color">5 Entries</div>
              <a onClick={()=>{tweetOnTwitter(address)}} href="https://twitter.com/globuschain" target='_blank' className="cmn-btn btn-md mt-4">
                Attempt Task
              </a>
            </div>

          </div>
          )}
          {!user?.fDiscord && (
          <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
            <div
              className="package-card text-center bg_img"
              data-background="assets/images/bg/bg-4.png"
            >
              <h4 className="package-card__title base--color mb-2">Discord</h4>
              <ul className="package-card__features mt-4">
                <li>Join the GlobusChain discord</li>

              </ul>
              <div className="package-card__range mt-5 base--color">
                1 Entry
              </div>
              <a onClick={()=>{joinDiscord(address)}} href="https://discord.gg/VMq2WycFsN" target='_blank' className="cmn-btn btn-md mt-4">
                Attempt Task
              </a>
            </div>

          </div>
          )}
          {!user?.fTelegram && (
          <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
            <div
              className="package-card text-center bg_img"
              data-background="assets/images/bg/bg-4.png"
            >
              <h4 className="package-card__title base--color mb-2">Telegram </h4>
              <ul className="package-card__features mt-4">
                <li>Join the GlobusChain on telegram</li>

              </ul>
              <div className="package-card__range mt-5 base--color">
                1 Entry
              </div>
              <a  onClick={()=>{joinTelegram(address)}}  href="https://t.me/+ttwTfhBWPz5iOTA1" target='_blank' className="cmn-btn btn-md mt-4">
                Attempt Task
              </a>
            </div>

          </div>
          )} */}

              {/* <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
            <div
              className="package-card text-center bg_img"
              data-background="assets/images/bg/bg-4.png"
            >
              <h4 className="package-card__title base--color mb-2">Share</h4>
              <ul className="package-card__features mt-4">

                <li>Share with your friends</li>
              </ul>
              <div className="package-card__range mt-5 base--color">
                5 Entries
              </div>
           
               <a onClick={referral} className="cmn-btn btn-md mt-4">
                Your Referral Code
              </a>
            </div>

          </div> */}

              {/* {!user?.fInstagram && (
          <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
            <div
              className="package-card text-center bg_img"
              data-background="assets/images/bg/bg-4.png"
            >
              <h4 className="package-card__title base--color mb-2">Instagram</h4>
              <ul className="package-card__features mt-4">
                <li>Follow and like GlobusChain on instagram </li>

              </ul>
              <div className="package-card__range mt-5 base--color">1 Entry</div>
              <a  onClick={()=>{followOnInsta(address)}}  href="https://www.instagram.com/globuschain/" target='_blank' className="cmn-btn btn-md mt-4">
                Attempt Task
              </a>
            </div>

          </div>
          )}
          {!user?.Youtube && (
          <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
            <div
              className="package-card text-center bg_img"
              data-background="assets/images/bg/bg-4.png"
            >
              <h4 className="package-card__title base--color mb-2">YouTube</h4>
              <ul className="package-card__features mt-4">
                <li>Follow and like GlobusChain on YouTube</li>

              </ul>
              <div className="package-card__range mt-5 base--color">
                1 Entry
              </div>
              <a onClick={()=>{followOnYoutube(address)}}  href="https://www.youtube.com/@globuschain" target='_blank' className="cmn-btn btn-md mt-4">
                Attempt Task
              </a>
            </div>

          </div>
          )}
          {!user?.Retweet && (
          <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
            <div
              className="package-card text-center bg_img"
              data-background="assets/images/bg/bg-4.png"
            >
              <h4 className="package-card__title base--color mb-2">Retweet</h4>
              <ul className="package-card__features mt-4">
                <li>Retweet GlobusChain pinned message on Twitter</li>

              </ul>
              <div className="package-card__range mt-5 base--color">
                1 Entry
              </div>
              <a onClick={()=>{retweet(address)}}  href="https://twitter.com/globuschain" target='_blank' className="cmn-btn btn-md mt-4">
                Attempt Task
              </a>
            </div>

          </div>
          )} */}
            </div>
          </>
        )}
        {/* 
        {isConnected && (
          <div className="row mt-50">
            <div className="col-lg-12 text-center">
              <a onClick={referral} className="cmn-btn">
                Your Referral Code
              </a>
            </div>
          </div>
        )} */}
        <h6 style={{ textAlign: 'center', padding: '40px' }}>
          Good luck, and remember eligible entries must hold the equivalent of $100 of GLSC at the time of the prize draw. Winner will be announced on 10th of Jan 2024.
          to buy visit our website <a href='https://GlobusChain.com' target='_blank'>https://GlobusChain.com</a>
        </h6>
      </div>
    </section>

  );
}